module.exports = __webpack_public_path__ + "static/media/penill.ec4053c1.svg";